import React from 'react';
import {
    workflow1,
    workflow2,
    workflow3,
    workflowLine1,
    workflowLine2,
} from '../../assets/images';

import styles from './styles.module.scss';

const AdvertisingWorkflowImage = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.items}>
                <img src={workflow1} alt="Advertising Agency" />
                <img src={workflow2} alt="Post Production" />
                <img src={workflow3} alt="Broadcaster" />
            </div>
            <div className={styles.lines}>
                <img src={workflowLine2} alt="workflow line" />
                <img src={workflowLine1} alt="workflow line" />
            </div>
        </div>
    );
};

export default AdvertisingWorkflowImage;